var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-grid-vue',{class:_vm.getTheme,staticStyle:{"width":"100%"},attrs:{"columnDefs":_vm.columnDefs,"defaultColDef":_vm.defaultColDef,"gridOptions":_vm.gridOptions,"groupDefaultExpanded":-1,"localeText":_vm.localeText,"pinnedTopRowData":_vm.pinnedTopRowData,"rowData":_vm.rowData,"sideBar":_vm.sideBar,"tooltipShowDelay":_vm.tooltipShowDelay}})
}
var staticRenderFns = []

export { render, staticRenderFns }